(function () {
	const alphabetFilter = document.querySelectorAll('.infusions-alphabet-filter');

	if (!alphabetFilter.length || alphabetFilter === null || alphabetFilter === undefined) {
		return;
	}

	class InfusionsAlphabetFilter {
		constructor(element) {
			this.element = element;
			this.AlphabetBtns = this.element
				.querySelector('.alphabet-filter')
				.querySelectorAll('.filter-button');
			this.cardTitles = this.element.querySelectorAll('.sh-accordion__title');
			this.activeBtn = null;
		}

		init() {
			this.setAlphabetFilter();
			this.addEventListeners();
		}

		addEventListeners() {
			this.AlphabetBtns.forEach(btn => {
				let letter = btn.dataset.filter;
				btn.addEventListener('click', () => {
					if (this.activeBtn) {
						this.activeBtn.classList.remove('active');
					}
					this.filterItems(letter);
				});
			});
		}

		filterItems(letter) {
			// console.log(letter);
			this.cardTitles.forEach(title => {
				let firstLetter = title.textContent.trim().charAt(0).toLocaleUpperCase();
				if (firstLetter === letter) {
					console.log(firstLetter);
					this.scrollToItem(title);
					// Get the parent element of the title .infusion-card
					let card = title.closest('.sh-accordion__item');
					card.classList.add('flashing');
					setTimeout(() => {
						card.classList.remove('flashing');
					}, 2900);
					// this.activeBtn = document.querySelector(`[data-filter="${letter}"]`);
					this.activeBtn = this.element.querySelector(`[data-filter="${letter}"]`);
					this.activeBtn.classList.add('active');
					// exit;
				}
			});
		}

		// Filter through every item and store the first letter in an array
		// If the letter does not exist, add the .filter-button--disabled class to the letter

		setAlphabetFilter() {
			let alphabet = [];
			this.cardTitles.forEach(title => {
				let firstLetter = title.textContent.trim().charAt(0).toLocaleUpperCase();
				if (!alphabet.includes(firstLetter)) {
					alphabet.push(firstLetter);
				}
			});

			this.AlphabetBtns.forEach(btn => {
				let letter = btn.dataset.filter.trim().toLocaleUpperCase();
				if (!alphabet.includes(letter)) {
					btn.classList.add('filter-button--disabled');
				}
			});
		}

		scrollToItem(item) {
			if (this.element.closest('.modal-infusions')) {
				let navigationHeight = document.querySelector('.site-header').offsetHeight + 40;
				gsap.to('.modal__content', {
					duration: 1,
					scrollTo: { y: item, offsetY: navigationHeight },
					ease: 'power2.out',
				});
				return;
			}
			// dispatch a window resize event to update the scroll position

			let navigationHeight = document.querySelector('.site-header').offsetHeight + 70;
			gsap.to(window, {
				duration: 1,
				scrollTo: { y: item, offsetY: navigationHeight },
				ease: 'power2.out',
			});
		}
	}

	alphabetFilter.forEach(alphabetFilterItem => {
		const instance = new InfusionsAlphabetFilter(alphabetFilterItem);
		instance.init();
	});
})();
